import { BitbotLogoWithText, BitkitButton, rem } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { chakra } from '@chakra-ui/react/styled-system';
import { Text } from '@chakra-ui/react/text';

import InternalFooter from '@/components/InternalFooter/InternalFooter';

import bitrise500 from '../../../../../public/errors/bitrise_500.svg';

const Status500ErrorPageContent = () => (
  <Box
    display="flex"
    height="100vh"
    width="100vw"
    flexDirection="column"
    justifyContent="space-between"
    textAlign="center"
    color="text/on-color"
    background="linear-gradient(315deg, var(--colors-purple-30), var(--colors-purple-10))"
  >
    <Box
      display="flex"
      flexDirection={{ base: 'column', desktop: 'row' }}
      alignItems="center"
      flexGrow="1"
      padding="0 5%"
      gap="3rem"
      maxWidth="100rem"
      margin="0 auto"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="start"
        textAlign="left"
        gap="2rem"
        paddingTop={{ base: '3rem', desktop: '0' }}
        maxWidth={{ base: '100%', desktop: '40%' }}
      >
        <BitbotLogoWithText height="40" color="icon/on-color" />
        <Box>
          <Text textStyle="code/lg" marginBlockEnd="16" marginInlineEnd="16">
            500 - INTERNAL SERVER ERROR
          </Text>

          <Text
            as="h2"
            textStyle={{ base: 'sans/size-7/bold', desktop: 'sans/size-8/bold' }}
            marginBlockEnd="32"
            lineHeight="1.2"
          >
            We are sorry, a hairball got into the system
          </Text>

          <BitkitButton href="/" variant="tertiary" color="text/on-color">
            Go to dashboard
          </BitkitButton>
        </Box>
      </Box>

      <chakra.img src={bitrise500} alt="Bitrise - 500" paddingTop={rem(80)} />
    </Box>
    <InternalFooter background="transparent" variant="transparent" />
  </Box>
);

export default Status500ErrorPageContent;
